<template>
  <Fragment>
    <template v-if="$route.name !== 'categoryIndex'">
      <router-view></router-view>
    </template>
    <section class="container" v-else>
      <Breadcrumb />
      <div class="card-wrap mt-20 mb-20">
        <section class="card-content">
          <div class="left">
            <el-button
              type="primary"
              class="mr-20"
              @click="addDictionariesCategory"
              >新增应用分类</el-button
            >
          </div>
        </section>
      </div>
      <el-table :data="list" style="width: 100%" border>
        <el-table-column label="序号" width="50">
          <template slot-scope="scope">
            <span>{{ scope.$index + (pageNum - 1) * pageSize + 1 }}</span>
          </template>
        </el-table-column>
        <el-table-column label="应用分类" width="400">
          <template slot-scope="scope">
            <span>{{ scope.row.applicationCategoryName }}</span>
          </template>
        </el-table-column>
        <el-table-column label="节点号码" width="400">
          <template slot-scope="scope">
            <span>{{ scope.row.applicationCategoryCode }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" :fit="true">
          <template slot-scope="scope">
            <el-button
              size="mini"
              @click="editDictionariesCategoryInfo(scope.row)"
              >编辑</el-button
            >
            <el-button
              size="mini"
              type="danger"
              @click="deleteDictionariesCategory(scope.row)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="mt-20 pagination"
        background
        layout="total,prev, pager, next, jumper"
        :total="total"
        :page-size="10"
        :current-page="pageNum"
        @prev-click="handlePrePage"
        @next-click="handleNextPage"
        @current-change="handleCurrentChange"
      >
      </el-pagination>
    </section>
  </Fragment>
</template>

<script>
import { Fragment } from "vue-fragment";

import Breadcrumb from "@/components/Breadcrumb";
export default {
  name: "role",
  components: {
    Breadcrumb,
    Fragment
  },
  data() {
    return {
      list: [],
      pageNum: 1,
      pageSize: 10,
      total: 0
    };
  },
  methods: {
    getDictionariesCategoryList() {
      let _this = this;
      let param = {
        url: "/api/dictionaryCategory/getDictionaryCategoryPage",
        params: {
          pageNum: _this.pageNum,
          pageSize: _this.pageSize
        }
      };

      _this.$store.dispatch("getDictionariesCategoryList", param).then(() => {
        _this.list =
          _this.$store.state.dictionaries.dictionariesCategoryList.list;
        _this.total =
          _this.$store.state.dictionaries.dictionariesCategoryList.total;
      });
    },
    //查询
    searchDictionariesCategoryInfo() {
      let _this = this;
      _this.getDictionariesCategoryList();
    },
    //当前页
    handleCurrentChange(value) {
      let _this = this;
      _this.pageNum = value;
      _this.getDictionariesCategoryList();
    },
    //上一页
    handlePrePage() {
      let _this = this;
      _this.pageNum -= 1;
      _this.getDictionariesCategoryList();
    },
    //下一页
    handleNextPage() {
      let _this = this;
      _this.pageNum += 1;
      _this.getDictionariesCategoryList();
    },
    //编辑
    editDictionariesCategoryInfo(row) {
      this.$router.push({
        name: "editDictionariesCategoryInfo",
        params: { applicationCategoryId: row.applicationCategoryId }
      });
    },
    //删除
    deleteDictionariesCategory: function(row) {
      let _this = this;
      if (confirm("确定要删除吗") === true) {
        let param = {
          url: "/api/dictionaryCategory/deleteDictionaryCategoryInfoById",
          params: { applicationCategoryId: row.applicationCategoryId }
        };

        _this.$Api
          .get(param.url, param.params)
          .then(response => {
            if (response.status === 200) {
              _this.getDictionariesCategoryList();
              _this.$message({
                message: "二维码分类删除成功",
                type: "success"
              });
              this.$router.push({
                name: "categoryIndex"
              });
            } else {
              _this.$message({
                message: response.data.msg,
                type: "error"
              });
            }
          })
          .catch(err => {});
      }
    },
    //添加
    addDictionariesCategory() {
      this.$router.push({
        name: "addDictionariesCategory"
      });
    }
  },
  created() {
    let _this = this;
    _this.getDictionariesCategoryList();
  }
};
</script>

<style lang="sass" scoped>
.card-wrap
  .card-content
    display: flex
    align-items: center
    justify-content: space-between
    .left
      display: flex
    .el-button
      font-size: 14px
    .search-name, .search-code
      font-size: 14px
      display: flex
      align-items: center
      span
        white-space: nowrap
.pagination
  text-align: center
</style>
